import { useMutation } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { endSession, gqlClient } from '@/lib';
import type { QueryError } from '@/utils/errors';
import type {
  LogoutMutation,
  LogoutMutationVariables,
} from './useLogout.generated';

const query = gql`
  mutation Logout {
    logout
  }
`;

export const useLogout = () => {
  const { mutate } = useMutation<LogoutMutation, QueryError>({
    mutationFn: () => {
      return gqlClient.request<LogoutMutation, LogoutMutationVariables>(query);
    },
  });

  return {
    logout: ({ onSuccess }: { onSuccess: () => void }) => {
      mutate(undefined, {
        onSuccess: () => {
          // Shared with the 401 handler so the two can't drift: a session that
          // expires has to leave the app in the same state as one the user
          // ended deliberately.
          endSession();
          onSuccess();
        },
      });
    },
  };
};
